var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c('ul',{staticClass:"navigation"},_vm._l((_vm.menu),function(route,i){return _c('router-link',{key:i,staticClass:"navigation__item",attrs:{"to":route.link}},[_vm._v(" "+_vm._s(route.name)+" ")])}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }